import React, { Component, Fragment } from "react";
import styled from "@emotion/styled";
import { RouteData, SiteData } from "react-static";
import fetch from "isomorphic-unfetch";
import { Link } from "@reach/router";
import ReCAPTCHA from "react-google-recaptcha";

import BQ from "../components/hero-quote";
import Section from "../components/section";
import Seo from "../components/seo";
import RawButton from "../components/button";

const Button = styled(RawButton)`
  align-self: flex-start;
  margin: 2rem 0 0 0;
`;

const Wrapper = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const PostCard = styled.div`
  flex: 1;
  margin: 2rem 0;
  ${"" /* border: solid 1px black; */}
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  width: calc(100vw - 2rem);
  max-width: 800px;
  display: flex;
  font-family: "Atlas", monospace;
  font-size: smaller;
  form {
    flex: 1;
    min-height: 100%;
    display: flex;
    flex-flow: wrap row;
  }
`;

const FormInputs = styled.div`
  * {
    line-height: 1.5;
  }
  br {
    margin-top: 0.5rem;
  }
  label {
    width: 100%;
    display: flex;
    flex-flow: wrap row;
    align-items: baseline;
    font-family: "Atlas", monospace;
    span {
      white-space: nowrap;
      margin-right: 4px;
    }
    span.wrap {
      white-space: normal;
    }
    span.hidden {
      position: absolute;
      color: transparent;
      user-select: none;
      border-bottom: solid 1px black;
      padding-bottom: 0.5rem;
      cursor: text;
    }
  }
  textarea {
    width: 100%;
    flex: 1;
  }
  input,
  textarea {
    border: none;
    border-radius: none;
    box-shadow: none;
    font-size: inherit;
    font-family: inherit;
    margin-bottom: 0.5rem;
    flex: 1;
  }
  input::placeholder,
  textarea::placeholder {
    color: rgba(194, 194, 194, 1);
  }
  .underline {
    border-bottom: solid 1px;
  }
  br {
    margin-top: 1rem;
  }

  font-family: "Atlas", monospace;
  border-right: dashed 1px grey;

  @media (max-width: 850px) {
    border-right: 0;
    border-bottom: dashed 1px grey;
    margin: 0;
    padding: 2rem;
  }
  flex: 1;
  margin: 2rem 0;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
`;

const SendTo = styled.div`
  position: relative;
  flex: 1;
  margin: 2rem 0;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  br {
    margin-top: 1rem;
  }
`;

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

const FORM_STATE = Object.freeze({
  INIT: "INIT",
  VERIFYING: "VERIFYING",
  SENDING: "SENDING",
  SENT: "SENT",
  FAILED: "FAILED"
});

class ContactForm extends React.Component {
  render() {
    const { handleChange, value } = this.props;
    const { name, email, message, role, company, phone } = value;
    return (
      <Fragment>
        <label>Dear In Other Words team,</label>
        <br />
        <label>
          <span>I work for</span>
          <input
            className="underline"
            type="text"
            name="company"
            value={company}
            onChange={handleChange}
            placeholder="Company Name"
          />
        </label>
        <label>
          <span>as the</span>{" "}
          <input
            className="underline"
            type="text"
            name="role"
            value={role}
            onChange={handleChange}
            placeholder="role in Company"
          />
          .
        </label>
        <br />
        <label>
          <span className="wrap">
            I'm wondering if your collective can help me with:
          </span>
        </label>

        <textarea
          className="underline"
          name="message"
          value={message}
          onChange={handleChange}
          placeholder="- my problems"
        />
        <br />
        <label>
          <span>Call/text me at</span>
          <input
            className="underline"
            type="text"
            name="phone"
            value={phone}
            onChange={handleChange}
            placeholder="+62xxxxxxxxxxx"
          />
        </label>
        <label>
          <span>or email me at</span>
          <input
            className="underline"
            type="email"
            name="email"
            value={email}
            onChange={handleChange}
            placeholder="name@company.com"
          />
        </label>
        <label>so we can have a chat.</label>
        <br />
        <label>Cheers,</label>
        <br />
        <label>
          <span className="hidden">{name || "My Name"}</span>
          <input
            type="text"
            name="name"
            value={name}
            onChange={handleChange}
            placeholder="My Name"
          />
        </label>
      </Fragment>
    );
  }
}

const Stamp = styled.div`
  position: absolute;
  top: 0;
  right: 2rem;
  width: 4rem;
  height: 5rem;
  border: dotted 1px black;
`;

class Contact extends Component {
  state = {
    status: FORM_STATE.INIT,
    form: {
      name: "",
      email: "",
      message: "",
      role: "",
      company: "",
      phone: ""
    }
  };

  _reCaptchaRef = React.createRef();

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ status: FORM_STATE.VERIFYING });
  };

  handleRecaptchaChange = value => {
    this.setState({ status: FORM_STATE.SENDING });
    if (value) {
      const { form } = this.state;
      const encoded = encode({
        ...form,
        "form-name": "contact",
        "g-recaptcha-response": value
      });
      // console.log('sending', {form})
      const opts = {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encoded
      };
      // console.log({opts})
      fetch(`/?${encoded}`, opts)
        .then(() => new Promise(resolve => setTimeout(resolve, 2000)))
        .then(() => this.setState({ status: FORM_STATE.SENT }))
        .catch(() => this.setState({ status: FORM_STATE.FAILED }));
    } else {
      this.setState({ status: FORM_STATE.FAILED });
    }
  };

  handleChange = e => {
    e.persist();
    this.setState(state => ({
      ...state,
      form: {
        ...state.form,
        [e.target.name]: e.target.value
      }
    }));
  };

  render() {
    const { siteData, meta } = this.props;
    const { status, form: value } = this.state;
    const { name, email, message, role, company, phone } = value;

    const isFull =
      name !== "" &&
      email !== "" &&
      message !== "" &&
      role !== "" &&
      company !== "" &&
      phone !== "";

    const isPristine =
      name === "" &&
      email === "" &&
      message === "" &&
      role === "" &&
      company === "" &&
      phone === "";

    const isPreparing =
      status === FORM_STATE.INIT || status === FORM_STATE.VERIFYING;
    return (
      <Fragment>
        <Seo
          url="https://inotherwords.id/contact"
          siteTitle={siteData.data.title}
          pageTitle={meta.title}
          description={meta.description}
          image={meta.image}
          siteFBAppID={siteData.data.fbappid}
          userTwitter={siteData.data.twitter}
        />
        <Section
          title={
            isPreparing
              ? "Contact Us"
              : status === FORM_STATE.SENDING
              ? "Sending"
              : status === FORM_STATE.SENT
              ? "Thank You"
              : "Sorry"
          }
        >
          {isPreparing ? (
            <Wrapper>
              <PostCard>
                <form
                  name="contact"
                  data-netlify="true"
                  data-netlify-recaptcha="true"
                  netlify-honeypot="bot-field"
                  onSubmit={
                    isFull
                      ? this.handleSubmit
                      : () => alert("Please fill all of the fields")
                  }
                >
                  <input type="hidden" name="form-name" value="contact" />
                  <FormInputs>
                    <ContactForm
                      handleChange={this.handleChange}
                      value={value}
                    />
                  </FormInputs>
                  <SendTo>
                    <Stamp />
                    <span>To:</span>
                    <span>
                      <b>In Other Words</b>
                    </span>
                    <br />
                    <span>
                      <a href="https://api.whatsapp.com/send?text=Hello IOW&phone=+6281218893929">
                        +62812 1889 3929
                      </a>
                    </span>
                    <span>
                      <a href="mailto:avi@inotherwords.id">
                        avi@inotherwords.id
                      </a>
                    </span>
                    <span>
                      <Link exact href="/" to="/">
                        inotherwords.id
                      </Link>
                    </span>

                    <Button
                      type="button"
                      onClick={
                        isFull
                          ? this.handleSubmit
                          : () => alert("Please fill all of the fields")
                      }
                      color="white"
                      bgColor="orangered"
                      disabled={
                        isPristine || !isFull || status === FORM_STATE.VERIFYING
                      }
                    >
                      {status === FORM_STATE.VERIFYING
                        ? "Verify humanity"
                        : "Send"}
                    </Button>
                    {status === FORM_STATE.VERIFYING ? (
                      <ReCAPTCHA
                        key={this._reCaptchaRef}
                        sitekey={process.env.SITE_RECAPTCHA_KEY}
                        onChange={this.handleRecaptchaChange}
                      />
                    ) : null}
                  </SendTo>
                </form>
              </PostCard>
            </Wrapper>
          ) : status === FORM_STATE.SENDING ? (
            <BQ>Getting a messenger bird to send your message...</BQ>
          ) : status === FORM_STATE.SENT ? (
            <BQ>
              Your message has been received.
              <br />
              We will get back to you within the next 24 hours.
            </BQ>
          ) : status === FORM_STATE.FAILED ? (
            <BQ>
              Sorry, we could not send the message.
              <br />
              Please refresh the page and try again.
            </BQ>
          ) : (
            <BQ>
              Sorry, we could not send the message. An unknown error occured.
              <br />
              Please refresh the page and try again.
            </BQ>
          )}
        </Section>
      </Fragment>
    );
  }
}

export default () => (
  <SiteData>
    {siteData => (
      <RouteData>
        {routeData => <Contact {...routeData} siteData={siteData} />}
      </RouteData>
    )}
  </SiteData>
);
